import React from 'react';

import { useSuperHubStore } from '@core/store';

import type { EmptyStateProps } from '@routes/SuperHub/components/EmptyState';
import EmptyState from '@routes/SuperHub/components/EmptyState';

/**
 * Renders the empty state for Recipes (aka Tutorials).
 */
export default function EmptyRecipes({ onAction }: Pick<EmptyStateProps, 'onAction'>) {
  const isEditable = useSuperHubStore(s => s.user.role === 'admin' || s.user.role === 'editor');

  return <EmptyState onAction={isEditable ? onAction : undefined} section="recipe" />;
}
